import { render } from "./LicenseCard.vue?vue&type=template&id=1379e5cd&ts=true"
import script from "./LicenseCard.vue?vue&type=script&lang=ts"
export * from "./LicenseCard.vue?vue&type=script&lang=ts"

import "./LicenseCard.vue?vue&type=style&index=0&id=1379e5cd&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__